import { ApiClient, apiClient } from "../../../../core/api_client";
import { ISector, sectorFromJson } from "./entities";
import { Failure } from "../../../../core/failure";
import { getFiveRoomApartments } from "../../project/data/repo";

interface ISectorRepo {
  getSectorFloorDetail: (id: string) => Promise<ISector>;
}

const SectorRepoImplFactory = (apiClient: ApiClient): ISectorRepo => {
  const r: ISectorRepo = {
    getSectorFloorDetail: async (id) => {
      try {
        const res = await apiClient.get(`/getSectorFloors/${id}`);
        const sector = sectorFromJson(res.data);
        const firstFloor = res.data.floors?.[0];
        if (firstFloor && firstFloor.count_of_apartments?.fiveRoom === undefined) {
          const fiveRoomApartments = (await getFiveRoomApartments(firstFloor.project_plan_id)).filter(
            (a) => `${a.project_plan_sector_plan_id}` === `${id}`
          );
          sector.floors.forEach((floor) => {
            floor.etrance.fiveRoomCount = fiveRoomApartments.filter(
              (a) => `${a.floor_number}` === `${floor.number}`
            ).length;
          });
        }
        return sector;
      } catch (error: any) {
        const failure: Failure = {
          message: error.message ?? "Unhandled failure",
        };
        throw failure;
      }
    },
  };

  return r;
};

export const SectorRepoImpl = SectorRepoImplFactory(apiClient);
